import React, { PureComponent } from "react";
import DownIcon from "mdi-react/ChevronDownIcon";
import { Container, Collapse } from "reactstrap";
import client from "../../../shared/api-client";
import logout from "../../../shared/logout";
import login from "../../../shared/login";
import Modal from "../../../shared/modal";
import FormComponent from "./changePassword";
import Slider from "react-slide-out";

export default class TopbarProfile extends PureComponent {
  state = {
    collapse: false,
    isOpen: false,
    user: {
      name: "",
    },
    formValues: {
      password: "",
      confirm_password: "",
    },
    show: false,
  };

  componentDidMount() {
    this.getProfile();
  }

  getProfile = () => {
    client(`admin_profile.php`, {
      method: "GET",
    }).then(
      (response) => {
        this.setState({ user: response });
      },
      (error) => {
        this.setState({ show: true, errors: error._user_message, success: "" });
      }
    );
  };

  toggle = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  handleForm = (formValues) => {
    this.setState({ formValues }, () => {
      // Validations will be added here if required frontend validations
    });
  };

  submit = () => {
    if (this.state.formValues.password.trim() === "") {
      this.setState({
        show: true,
        errors: ["Please enter the password."],
        success: "",
      });
    } else if (
      this.state.formValues.password.trim() !==
      this.state.formValues.confirm_password.trim()
    ) {
      this.setState({
        show: true,
        errors: ["Confirm password does not matched."],
        success: "",
      });
    } else if (this.state.formValues.password.trim().length < 8) {
      this.setState({
        show: true,
        errors: ["Password must be min 8 characters."],
        success: "",
      });
    } else {
      this.updatePassword();
    }
  };

  updatePassword = () => {
    client(`/admin_profile.php`, {
      method: "PUT",
      body: {
        password: this.state.formValues.password,
      },
    }).then(
      (response) => {
        login(
          window.localStorage.getItem("X-Auth-AdminID"),
          response.admin_token
        );
        this.setState({
          show: true,
          success: response._user_message,
          errors: [],
          isOpen: false,
        });
      },
      (error) => {
        this.setState({ show: true, errors: error._user_message, success: "" });
      }
    );
  };

  render() {
    return (
      <Container>
        <div className="topbar__profile lineHeight5">
          <button className="topbar__avatar" onClick={this.toggle}>
            <p className="topbar__avatar-name">{this.state.user.name}</p>
            <DownIcon className="topbar__icon" />
          </button>
          {this.state.collapse && (
            <button className="topbar__back" onClick={this.toggle} />
          )}
          <Collapse isOpen={this.state.collapse} className="topbar__menu-wrap">
            <div className="topbar__menu ">
              <button
                className="menuButton"
                onClick={() => {
                  this.setState({ isOpen: true });
                }}
              >
                Change Password
              </button>
              <button
                className="menuButton"
                onClick={() => {
                  logout(() => {
                    window.location.assign("/");
                  });
                }}
              >
                Log Out
              </button>
            </div>
          </Collapse>
        </div>
        <Slider
          isOpen={this.state.isOpen}
          footer={
            <div className="button-container">
              <button
                className="square btn btn-primary btn-sm"
                onClick={() => this.submit()}
                type="button"
              >
                Submit
              </button>
              <button
                type="button"
                className="square btn btn-danger btn-sm"
                onClick={() => {
                  this.setState((prevState) => ({ isOpen: false }));
                }}
              >
                Cancel
              </button>
            </div>
          }
          onOutsideClick={() => this.setState({ isOpen: false })}
        >
          <FormComponent
            handleForm={(formValues) => this.handleForm(formValues)}
          />
        </Slider>
        <Modal
          onClose={() => this.setState({ show: false })}
          show={this.state.show}
          errors={this.state.errors}
          success={this.state.success}
        ></Modal>
      </Container>
    );
  }
}
